// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8b7f946c","523":"06659266"}[chunkId] + ".chunk.js";
};